import styled, { css } from 'styled-components'

import { LinkPrimaryButton, LinkSecondaryButton } from '../../../../../global/LinkButton'
import { RewardsCard } from '../../RewardsCard'
import { RewardsHeading4 } from '../../RewardsHeading'

import BasketSvg from '../../../../../../img/rewards/basket.inline.svg'
import ReceiptSvg from '../../../../../../img/rewards/receipt.inline.svg'

export const Heading4 = styled(RewardsHeading4)`
  margin-bottom: 0;
  margin-right: 0;
`

export const Card = styled(RewardsCard)`
  align-items: flex-start;
  gap: 8px;
  background-color: ${({ theme }) => theme.colors.coolGray.cool150};
`

export const NoticeCardContainer = styled.div`
  margin: 16px 0;
  width: 100%;
`

export const AvailableContainer = styled.div`
  font-size: 16px;
  margin-bottom: 0;
  font-family: ${({ theme }) => theme.fonts.global.headers};
  color: ${({ theme }) => theme.colors.brand.blue};
`

export const AvailableRewards = styled.span`
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 0;
  margin-right: 5px;
  font-family: ${({ theme }) => theme.fonts.global.headers};
  color: ${({ theme }) => theme.colors.brand.blue};
`

export const CashbackContainer = styled.div`
  font-size: 16px;
  margin-bottom: 0;
  font-family: ${({ theme }) => theme.fonts.global.headers};
  color: ${({ theme }) => theme.colors.blackPearlBlue.shade400};
`

export const Cashback = styled.span`
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 0;
  margin-right: 5px;
  margin-left: 5px;
  font-family: ${({ theme }) => theme.fonts.global.headers};
  color: ${({ theme }) => theme.colors.blackPearlBlue.shade400};
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  @media (min-width: 1024px) {
    flex-direction: row;
    gap: 24px;
  }
`

const buttonIconStyles = css`
  margin-right: 8px;
  vertical-align: bottom;
`

export const BasketIcon = styled(BasketSvg)`
  ${buttonIconStyles};
`

export const ReceiptIcon = styled(ReceiptSvg)`
  ${buttonIconStyles};
`

const buttonsStyles = css`
  font-size: 18px;
  width: 100%;
  text-transform: none;
`

export const ShopButton = styled(LinkPrimaryButton)`
  ${buttonsStyles};
  background-color: ${({ theme }) => theme.colors.component.PrimaryButton.default.background};

  &:hover {
    background-color: ${({ theme }) => theme.colors.component.PrimaryButton.hover.background};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.component.PrimaryButton.disabled.background};
  }
`

export const DetailsAndPayoutButton = styled(LinkSecondaryButton)`
  ${buttonsStyles};
  font-size: 16px;
  color: ${({ theme }) => theme.colors.component.SecondaryButton.default.text};
  background-color: ${({ theme }) => theme.colors.component.SecondaryButton.default.background};

  &:hover {
    background-color: ${({ theme }) => theme.colors.component.SecondaryButton.hover.background};
    color: ${({ theme }) => theme.colors.component.SecondaryButton.hover.text};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.component.SecondaryButton.disabled.background};
  }
`
